import React from 'react';
import classnames from 'classnames';

import * as styles from './Button.module.css';

export function Button({
  children,
  block,
  color = 'dark',
  size = 'medium',
  ...props
}) {
  const className = classnames(
    styles.Button,
    {
      [styles['Button-Block']]: block,
    },
    styles[`Button-Color-${color}`],
    styles[`Button-Size-${size}`],
  );

  return (
    <button className={className} {...props}>
      {children}
    </button>
  );
}
